import { ESection } from '../../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequestSchema';
import {
  fetchChatsBulkOperationsMoveAllFromSectionToArchiveDesktop,
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse,
} from '../../repositories/chats/v1/chats/bulk-operations/move-all-from-section-to-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { toggleChatListPending } from '../chatList/actions';

/**
 * Перенести в архив все чаты
 * @param {ESection} section раздел в котором нужно удалить сообщения
 */
export const archiveAllChats =
  (section: ESection): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse =
        await fetchChatsBulkOperationsMoveAllFromSectionToArchiveDesktop({
          httpApi,
          parameters: {
            section,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode !== 200) {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось перенести в архив все чаты',
          domain: 'src/shared/actions/chatList/archiveAllChats.ts',
          statusCode,
          messsage: response.message || 'Неизвестная ошибка',
          errors: JSON.stringify(response?.errors),
        });

        dispatch(showAlert({ message: 'Не удалось перенести в архив все чаты' }));
      }
    } catch (ex) {
      logger.error(ex, {
        message: 'Не удалось перенести в архив все чаты',
        domain: 'src/shared/actions/chatList/archiveAllChats.ts',
      });

      dispatch(showAlert({ message: 'Не удалось перенести в архив все чаты' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
